module.exports = __webpack_public_path__ + "img/feature_e03.88b07cd2.svg";